import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../../context/LanguageContext";
import dashboardContent from "../../../../utils/dashboardContent";
import { useAuth } from "../../../../context/authContext";
import { Button } from "antd";

const SuccessPage = () => {
  const { language } = useLanguage();
  const text = dashboardContent[language].successPage;
  const { fetchUser } = useAuth();
  const navigate = useNavigate();

  // Countdown (optional) und Interval
  const [remaining, setRemaining] = useState(10); // initial 10s
  const intervalMs = 1000; // 1s
  const maxWait = 10000; // 10s

  useEffect(() => {
    let elapsed = 0;
    const timer = setInterval(async () => {
      elapsed += intervalMs;
      setRemaining(Math.max(0, (maxWait - elapsed) / 1000));

      // Poll user subscription
      const user = await fetchUser();
      if (user.subscription.status === "active" || elapsed >= maxWait) {
        clearInterval(timer);
        navigate("/dashboard");
      }
    }, intervalMs);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-green-200 to-green-100 p-6">
      <div className="bg-white shadow-xl rounded-lg p-8 max-w-md text-center space-y-4">
        <h1 className="text-4xl font-extrabold text-green-600">{text.title}</h1>
        <p className="text-lg text-gray-800">{text.message}</p>
        <p className="text-sm text-gray-500 italic">
          {text.redirecting}
          {typeof remaining === "number" && ` (${remaining}s)`}
        </p>
        <p className="text-sm text-gray-500">{text.stayOpen}</p>

        {/* Manueller Button */}
        <Button type="primary" onClick={() => navigate("/dashboard")}>
          {text.buttonText}
        </Button>
      </div>
    </div>
  );
};

export default SuccessPage;
